/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */



import {Component} from '@angular/core';
import {LoadingListener} from '../../utils/loading/loading-listener';
export class LoadingButton implements LoadingListener {
public loading: Boolean;
/**
 * @return {?}
 */
startLoading(): void {
        this.loading = true;
    }
/**
 * @return {?}
 */
doneLoading(): void {
        this.loading = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "button[clrLoading]",
    template: `
        <span class="spinner spinner-inline" *ngIf="loading"></span>
        <ng-content></ng-content>
    `,
    providers: [{provide: LoadingListener, useExisting: LoadingButton}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LoadingButton_tsickle_Closure_declarations() {
/** @type {?} */
LoadingButton.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LoadingButton.ctorParameters;
/** @type {?} */
LoadingButton.prototype.loading;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
